import { addMinutes, differenceInMinutes, isAfter } from "date-fns";

interface AutoBreakTimes {
  autoBreakStartTime: Date;
  autoBreakEndTime: Date;
}

export function calculateAutoBreakTimes(
  clockInTime: Date,
  clockOutTime: Date,
  mandatoryBreakDurationInMinutes: number
): AutoBreakTimes | undefined {
  const shiftDurationMinutes = differenceInMinutes(clockOutTime, clockInTime);

  if (shiftDurationMinutes <= mandatoryBreakDurationInMinutes) {
    return undefined;
  }

  const halfShiftMinutes = shiftDurationMinutes / 2;

  const autoBreakStartTime = addMinutes(clockInTime, halfShiftMinutes);
  const autoBreakEndTime = addMinutes(autoBreakStartTime, mandatoryBreakDurationInMinutes);

  if (isAfter(autoBreakEndTime, clockOutTime)) {
    return undefined;
  }

  return { autoBreakStartTime, autoBreakEndTime };
}
